<template>
  <div class="page_salaryProcessSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>基础配置</el-breadcrumb-item>
          <el-breadcrumb-item>流程管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">

        <el-tabs v-model="listQuery.FlowName" type="card" @tab-click="changeTab">
          <el-tab-pane label="发薪流程" name="发薪流程"></el-tab-pane>
          <!-- <el-tab-pane label="预支工资流程" name="预支工资流程"></el-tab-pane>
          <el-tab-pane label="工伤工资" name="工伤工资"></el-tab-pane>
          <el-tab-pane label="其他" name="其他"></el-tab-pane> -->
          <el-tab-pane label="暂支核销流程" name="暂支核销"></el-tab-pane>
          <el-tab-pane label="日志核销" name="日志核销"></el-tab-pane>
          <el-tab-pane label="电子签流程" name="电子签流程"></el-tab-pane>
        </el-tabs>

        <div class="stepBox flex">
          <div class="stepTitle">缺省流程： </div>
          <el-steps :active="active" finish-status="success" style="width:400px">
            <el-step title="申请人"></el-step>
            <el-step title="业务审批" v-if="listQuery.FlowName=='预支工资流程'"></el-step>
            <el-step title="出纳确认"></el-step>
          </el-steps>
        </div>
        <el-tabs v-model="listQuery.NodeName" @tab-click="changeTab">
          <el-tab-pane label="主管审批" name="主管审批"></el-tab-pane>
          <el-tab-pane label="业务审批" name="业务审批"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNewRule">+新增审批规则</el-button>
        </div>

        <el-table :data="tableData" class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="NodeName" label="审批节点" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Priority" label="审批优先级" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Source" label="满足条件" min-width="200" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.DesignatedEnable=='1' ? '指定申请人：' + row.Designated + '; ' : ''}}
              {{ row.ServiceDepEnable=='1' ? '指定服务部门：' + row.ServiceDep + '; ' : ''}}
              {{ row.ProjectCsEnable=='1' ? '指定项目客服：' + row.ProjectCs + '; ' : ''}}
              {{ row.PartnerEnable=='1' ? '指定合伙人：' + row.Partner + '; ' : ''}}
              {{ row.AttrPerforEnable=='1' ? '指定业绩归属人' + row.AttrPerfor + '; ' : ''}}
              {{ row.ProjectOperEnable=='1' ? '指定项目运营：' + row.ProjectOper + '; ' : ''}}
              {{ row.ProjectEnable=='1' ? '指定项目：' + row.Project + '; ' : ''}}
              {{ row.ServiceTypeEnable=='1' ? '指定业务类型：' + row.ServiceType + '; ' : ''}}
              {{ row.DepositMinEnable=='1' ? ( listQuery.FlowName =='发薪流程' ? '指定垫资金额：≥' : listQuery.FlowName =='发薪流程' ? '核销金额：≥' : '金额：≥') + row.DepositMin + '; ' : ''}}
              {{ row.DepositEnable=='1' ? ( listQuery.FlowName =='发薪流程' ? '指定垫资金额' : listQuery.FlowName =='发薪流程' ? '核销金额' : '金额') + row.Deposit1 + ' ~ ' +  + row.Deposit2 + '; ' : ''}}
              {{ row.FinalPayingAmountMinEnable=='1' ? '指定发薪金额：≥' + row.FinalPayingAmountMin + '; ' : ''}}
              {{ row.ServiceTypeEnable=='1' ? '指定发薪金额：' + row.FinalPayingAmount1 + ' ~ ' + row.FinalPayingAmount2 + '; ' : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="OptionUserName" label="审批人" min-width="130" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.Examiners=='指定人员' ? row.Examiners + '：' + row.Designee : row.Examiners}}
            </template>
          </el-table-column>
          <el-table-column prop="CreateUserName" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Enable" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.Enable=='0' ? '停用': '启用'}}
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="180px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm :title="row.Enable=='0' ? '请确定是否启用？' : '请确定是否停用？'" @confirm="stop(row)" style="margin:0 10px;">
                  <el-button type="text" slot="reference">{{row.Enable=='0' ? '启用' : '停用'}}</el-button>
                </el-popconfirm>
                <el-button type="text" @click="del(row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalcount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="type == 'add' ?  '新增审批规则' : '编辑审批规则'" :visible.sync="showAddRule" width="1000px">
      <el-form :model="ruleForm" label-width="140px">

        <el-form-item label="选择审批节点">
          <template #label>
            <div class="formTitle"><span>|</span> 选择审批节点</div>
          </template>
          <el-select v-model="ruleForm.NodeName" placeholder="" clearable filterable size="small" style="width:300px">
            <el-option value="主管审批"></el-option>
            <el-option value="业务审批" v-if="listQuery.FlowName=='发薪流程'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批审核人：">
          <el-radio-group v-model="ruleForm.Examiners">
            <el-radio label="业务团队长">业务团队长</el-radio>
            <el-radio label="申请人直属上级">申请人直属上级</el-radio>
            <el-radio label="项目业绩归属人">项目业绩归属人</el-radio>
            <el-radio label="指定人员">指定人员</el-radio>
            <el-select v-model="Designee" value-key="Userid" placeholder="请选择指定人员" v-if="ruleForm.Examiners=='指定人员'" clearable filterable size="small" style="width:150px" @change="val => { changeDesignee(val) }">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批优先级：">
          <div class="flex">
            <el-input v-model="ruleForm.Priority" type="number" style="width:120px" size="small"></el-input>
            <div class="PriorityTips">注：数字越大，优先级越高</div>
          </div>
        </el-form-item>

      <div class="formTitle formTitle2"><span>|</span> {{listQuery.FlowName == '发薪流程' ? '项目满足条件' : '申请人满足条件'}}</div>

        <div style="padding-left:30px">
          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.DesignatedEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指定申请人：</el-checkbox>
            </template>
            <el-select v-model="Designated" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item) in userList" :key="item.Userid" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.ServiceDepEnable" true-label="1" false-label="0">&nbsp;&nbsp;指定服务部门：</el-checkbox>
            </template>
            <el-cascader :options="departmentList" placeholder="" size="small" style="width:300px" ref="cascader" v-model="ServiceDep" :props="{
                checkStrictly: true,
                multiple: true,
                value: 'strorgancode',
                label: 'strorganname',
              }" filterable clearable :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.ProjectCsEnable" true-label="1" false-label="0">&nbsp;&nbsp;指定项目客服：</el-checkbox>
            </template>
            <el-select v-model="ProjectCs" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.PartnerEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指定合伙人：</el-checkbox>
            </template>
            <el-select v-model="Partner" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.AttrPerforEnable" true-label="1" false-label="0">指定业绩归属人：</el-checkbox>
            </template>
            <el-select v-model="AttrPerfor" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.ProjectOperEnable" true-label="1" false-label="0">&nbsp;&nbsp;指定项目运营：</el-checkbox>
            </template>
            <el-select v-model="ProjectOper" value-key="Userid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.ProjectEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指定项目：</el-checkbox>
            </template>
            <el-select v-model="Project" value-key="Projectid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="listQuery.FlowName=='发薪流程'">
            <template #label>
              <el-checkbox v-model="ruleForm.ServiceTypeEnable" true-label="1" false-label="0">&nbsp;&nbsp;指定业务类型：</el-checkbox>
            </template>
            <el-select v-model="ServiceType" value-key="strParameterid" placeholder="" clearable filterable multiple size="small" style="width:300px">
              <el-option v-for="(item, index) in treeList" :key="index" :label="item.strParametername" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="formTitle formTitle2" v-if="listQuery.FlowName!='电子签流程'"><span>|</span>{{listQuery.FlowName=='发薪流程' ? '垫资金额满足条件' : '核销金额满足条件'}} </div>
        <div style="padding-left:30px"  v-if="listQuery.FlowName!='电子签流程'">
          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.DepositMinEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{listQuery.FlowName=='发薪流程' ? '垫资金额：' : '核销金额：'}}</el-checkbox>
            </template>
            <div class="flex">
              <div class="symbol">≥</div>
              <el-input v-model="ruleForm.DepositMin" type="number" style="width:120px" size="small"></el-input>
              <div class="unit">元</div>
            </div>
          </el-form-item>

          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.DepositEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{listQuery.FlowName=='发薪流程' ? '垫资金额：' : '核销金额：'}}</el-checkbox>
            </template>
            <div class="flex">
              <el-input v-model="ruleForm.Deposit1" type="number" style="width:120px" size="small"></el-input>
              <div class="unit"> ~ </div>
              <el-input v-model="ruleForm.Deposit2" type="number" style="width:120px" size="small"></el-input>
              <div class="unit">元</div>
            </div>
          </el-form-item>
        </div>


        <div class="formTitle formTitle2" v-if="listQuery.FlowName=='发薪流程'"><span>|</span> 发薪金额满足条件</div>
        <div style="padding-left:30px" v-if="listQuery.FlowName=='发薪流程'">
          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.FinalPayingAmountMinEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发薪金额：</el-checkbox>
            </template>
            <div class="flex">
              <div class="symbol">≥</div>
              <el-input v-model="ruleForm.FinalPayingAmountMin" type="number" style="width:120px" size="small"></el-input>
              <div class="unit">元</div>
            </div>
          </el-form-item>

          <el-form-item>
            <template #label>
              <el-checkbox v-model="ruleForm.FinalPayingAmountEnable" true-label="1" false-label="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发薪金额：</el-checkbox>
            </template>
            <div class="flex">
              <el-input v-model="ruleForm.FinalPayingAmount1" type="number" style="width:120px" size="small"></el-input>
              <div class="unit"> ~ </div>
              <el-input v-model="ruleForm.FinalPayingAmount2" type="number" style="width:120px" size="small"></el-input>
              <div class="unit">元</div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddRule = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" :loading="isloading" @click="confirmSubmit">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from "@/utils/permission"; // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          FlowName: '发薪流程',
          NodeName: '主管审批',
          pageNum: 1,
          pageSize: 10,
        },
        active: 0,
        loading: false,
        activeName: '0',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        userList: [], //用户列表
        showAddRule: false, //详情弹窗
        logTypeList: [], //操作类型列表
        optionType: '',
        type: '', //add / edit 
        ruleForm: {
          Enable: '1', //1启用 0停用
          FlowName: '发薪流程', //发薪/预支
          NodeName: '主管审批', //审批节点
          Priority: 0,
          Examiners: '', //审批审核人
          Designee: '', //审批指定人员
          DesigneeIds: '', //审批指定人员id
          Designated: '', //指定申请人
          DesignatedIdsStr: '',
          DesignatedEnable: 0, //指定申请人1为启用0为禁用
          ServiceDepId: '', //指定服务部门ids
          ServiceDep: '', //
          ServiceDepEnable: 0, //指定服务部门1为启用0为禁用
          ProjectCs: '', //指定项目客服
          ProjectCsStr: '', //
          ProjectCsEnable: 0, //指定项目客服1为启用0为禁用
          ProjectOper: '', //指定项目运营
          ProjectOperIds: '', //
          ProjectOperEnable: 0, //指定项目运营1为启用0为禁用
          Project: '', //指定项目
          ProjectIds: '', //
          ProjectEnable: 0, //指定项目1为启用0为禁用
          AttrPerfor: '', //指定业绩归属人
          AttrPerforIds: '', //指定业绩归属人ids
          AttrPerforEnable: 0, //指定业绩归属人1为启用0为禁用
          ServiceType: '', //指定业务类型
          ServiceTypeIds: '',
          ServiceTypeEnable: 0, //指定业务类型1为启用0为禁用
          DepositMin: '', //垫资金额MIN
          DepositMinEnable: 0, //垫资金额MIN1为启用0为禁用
          DepositEnable: 0, //垫资金额区域1为启用0为禁用
          Deposit1: '', //垫资金额1
          Deposit2: '', //垫资金额2
          FinalPayingAmountMin: '', //发薪金额MIN
          FinalPayingAmountMinEnable: 0, //发薪金额MIN1为启用0为禁用
          FinalPayingAmountEnable: 0, //发薪金额区域1为启用0为禁用
          FinalPayingAmount1: '', //发薪金额区域1
          FinalPayingAmount2: '', //发薪金额区域2
          Partner: '', //指定合伙人
          PartnerIds: '', //指定合伙人ids
          PartnerEnable: 0, //指定合伙人1为启用0为禁用
        },
        Designee: '',
        Designated: [],
        ServiceDep: [],
        ProjectCs: [],
        Partner: [],
        AttrPerfor: [],
        ProjectOper: [],
        Project: [],
        ServiceType: [],
        // 部门列表
        departmentList: [],
        proNameList: [],
        treeList: [], //业务类型列表
        isloading: false,
      };
    },
    created() {
      this.getUserList();
      this.getDepartData();
      this.getProList();
      this.getTreestr();
      this.getApprovalConfigList();
    },
    methods: {
      checkPermission,
      //获取用户列表
      getUserList() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        };
        let arr = [];
        xz.getauthUserInfoByorgancode(dataPage).then((res) => {
          if (res && res.totalcount > 0) {
            this.userList = res.msg;
            // res.msg.forEach(element => {
            //   arr.push({
            //     Username:element.Username,
            //     Userid:element.Userid
            //   })
            // });
            // this.userList = arr;
            // console.log(this.userList)
          } else {
            this.userList = [];
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取业务类型
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: '',
          keyword: ''
        }
        xz.getTreestr('JB_base_Busitype', data).then(res => {
          if (res) {
            this.treeList = res.msg.parent;
          } else {
            this.treeList = [];
          }
          this.treeLoading = false;
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getApprovalConfigList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getApprovalConfigList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getApprovalConfigList();
      },
      //获取审批配置列表
      getApprovalConfigList() {
        this.loading = true;
        xz.getApprovalConfigList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.tableData = res.data.data;
            this.totalcount = res.data.totalcount;
          } else {
            this.loading = false;
            this.tableData = [];
            this.totalcount = 0;
            this.$message.error(res.msg)
          }
        })
      },
      // 获取部门列表
      getDepartData() {
        let query = {
          strIsDisable: "1",
        };
        xz.getorganstr1("", "", query).then((res) => {
          // console.log('gg',res)
          if (res && !this.isNull(res.parent)) {
            this.departmentList = res.parent[0].children;
          } else {
            this.departmentList = [];
          }
        });
      },
      changeTab() {
        this.getApprovalConfigList();
      },
      //新增
      addNewRule() {
        this.type = 'add';
        this.showAddRule = true;
        this.clearForm();
        this.ruleForm.NodeName = this.listQuery.NodeName;
      },
      clearForm() {
        this.Designated = [];
        this.ServiceDep = [];
        this.ProjectCs = [];
        this.Partner = [];
        this.AttrPerfor = [];
        this.ProjectOper = [];
        this.Project = [];
        this.ServiceType = [];

        this.ruleForm = {
          Enable: '1', //1启用 0停用
          FlowName: this.listQuery.FlowName, //发薪/预支
          NodeName: '主管审批', //审批节点
          Priority: 0,
          Examiners: '', //审批审核人
          Designee: '', //审批指定人员
          DesigneeIds: '', //审批指定人员id
          Designated: '', //指定申请人
          DesignatedIdsStr: '',
          DesignatedEnable: 0, //指定申请人1为启用0为禁用
          ServiceDepId: '', //指定服务部门ids
          ServiceDep: '', //
          ServiceDepEnable: 0, //指定服务部门1为启用0为禁用
          ProjectCs: '', //指定项目客服
          ProjectCsStr: '', //
          ProjectCsEnable: 0, //指定项目客服1为启用0为禁用
          ProjectOper: '', //指定项目运营
          ProjectOperIds: '', //
          ProjectOperEnable: 0, //指定项目运营1为启用0为禁用
          Project: '', //指定项目
          ProjectIds: '', //
          ProjectEnable: 0, //指定项目1为启用0为禁用
          AttrPerfor: '', //指定业绩归属人
          AttrPerforIds: '', //指定业绩归属人ids
          AttrPerforEnable: 0, //指定业绩归属人1为启用0为禁用
          ServiceType: '', //指定业务类型
          ServiceTypeIds: '',
          ServiceTypeEnable: 0, //指定业务类型1为启用0为禁用
          DepositMin: '', //垫资金额MIN
          DepositMinEnable: 0, //垫资金额MIN1为启用0为禁用
          DepositEnable: 0, //垫资金额区域1为启用0为禁用
          Deposit1: '', //垫资金额1
          Deposit2: '', //垫资金额2
          FinalPayingAmountMin: '', //发薪金额MIN
          FinalPayingAmountMinEnable: 0, //发薪金额MIN1为启用0为禁用
          FinalPayingAmountEnable: 0, //发薪金额区域1为启用0为禁用
          FinalPayingAmount1: '', //发薪金额区域1
          FinalPayingAmount2: '', //发薪金额区域2
          Partner: '', //指定合伙人
          PartnerIds: '', //指定合伙人ids
          PartnerEnable: 0, //指定合伙人1为启用0为禁用
        }
      },
      //选择审批指定人
      changeDesignee(val) {
        console.log(val)
        this.ruleForm.Designee = val.Username;
        this.ruleForm.DesigneeIds = val.Userid;
      },
      confirmSubmit() {
        if (this.Designated.length > 0) { //指定申请人
          let name = [];
          let ids = [];
          this.Designated.forEach((element, index) => {
            name.push(element.Username)
            ids.push(element.Userid)
            if (index + 1 == this.Designated.length) {
              this.ruleForm.Designated = name.toString();
              this.ruleForm.DesignatedIdsStr = ids.toString();
            }
          });
        } else {
          this.ruleForm.Designated = '';
          this.ruleForm.DesignatedIdsStr = '';
        }
        if (this.ServiceDep.length > 0) { //指定服务部门
          // console.log(this.ServiceDep)
          let ids = [];
          this.ServiceDep.forEach((element, index) => {
            ids.push(element[element.length - 1])
            if (index + 1 == this.ServiceDep.length) {
              this.ruleForm.ServiceDepId = ids.toString();
            }
          });
        } else {
          this.ruleForm.ServiceDepId = '';
        }
        if (this.ProjectCs.length > 0) { //指定项目客服
          let name = [];
          let ids = [];
          this.ProjectCs.forEach((element, index) => {
            name.push(element.Username)
            ids.push(element.Userid)
            if (index + 1 == this.ProjectCs.length) {
              this.ruleForm.ProjectCs = name.toString();
              this.ruleForm.ProjectCsStr = ids.toString();
            }
          });
        } else {
          this.ruleForm.ProjectCs = '';
          this.ruleForm.ProjectCsStr = '';
        }
        if (this.Partner.length > 0) { //指定合伙人
          let name = [];
          let ids = [];
          this.Partner.forEach((element, index) => {
            name.push(element.Username)
            ids.push(element.Userid)
            if (index + 1 == this.Partner.length) {
              this.ruleForm.Partner = name.toString();
              this.ruleForm.PartnerIds = ids.toString();
            }
          });
        } else {
          this.ruleForm.Partner = '';
          this.ruleForm.PartnerIds = '';
        }
        if (this.AttrPerfor.length > 0) { //指定业绩归属人
          let name = [];
          let ids = [];
          this.AttrPerfor.forEach((element, index) => {
            name.push(element.Username)
            ids.push(element.Userid)
            if (index + 1 == this.AttrPerfor.length) {
              this.ruleForm.AttrPerfor = name.toString();
              this.ruleForm.AttrPerforIds = ids.toString();
            }
          });
        } else {
          this.ruleForm.AttrPerfor = '';
          this.ruleForm.AttrPerforIds = '';
        }
        if (this.ProjectOper.length > 0) { //指定项目运营
          let name = [];
          let ids = [];
          this.ProjectOper.forEach((element, index) => {
            name.push(element.Username)
            ids.push(element.Userid)
            if (index + 1 == this.ProjectOper.length) {
              this.ruleForm.ProjectOper = name.toString();
              this.ruleForm.ProjectOperIds = ids.toString();
            }
          });
        } else {
          this.ruleForm.ProjectOper = '';
          this.ruleForm.ProjectOperIds = '';
        }
        if (this.Project.length > 0) { //指定项目
          let name = [];
          let ids = [];
          this.Project.forEach((element, index) => {
            name.push(element.StrprojectName)
            ids.push(element.Projectid)
            if (index + 1 == this.Project.length) {
              this.ruleForm.Project = name.toString();
              this.ruleForm.ProjectIds = ids.toString();
            }
          });
        } else {
          this.ruleForm.Project = '';
          this.ruleForm.ProjectIds = '';
        }
        if (this.ServiceType.length > 0) {
          let name = [];
          let ids = [];
          this.ServiceType.forEach((element, index) => {
            name.push(element.strParametername)
            ids.push(element.strParameterid)
            if (index + 1 == this.Project.length) {
              this.ruleForm.ServiceType = name.toString();
              this.ruleForm.ServiceTypeIds = ids.toString();
            }
          });
        } else {
          this.ruleForm.ServiceType = '';
          this.ruleForm.ServiceTypeIds = '';
        }
        this.isloading = true;
        xz.updataApprovalConfig(this.ruleForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.isloading = false;
            this.getApprovalConfigList();
            this.$message.success('保存成功');
            this.showAddRule = false;
          } else {
            this.isloading = false;
            this.showAddRule = false;
            this.$message.error(res.msg)
          }
        })
      },
      edit(row) {
        this.type = 'edit';
        this.clearForm();
        xz.getApprovalConfig(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.ruleForm = res.data;
            if (res.data.Designee) {
              this.Designee = res.data.Designee
            }
            if (res.data.Designated) {
              try {
                let name = res.data.Designated.split(',');
                let ids = res.data.DesignatedIdsStr.split(',');
                name.forEach((element, index) => {
                  let data = {
                    Username: element,
                    Userid: ids[index]
                  }
                  this.Designated.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.ProjectCs) {
              try {
                let name = res.data.ProjectCs.split(',');
                let ids = res.data.ProjectCsStr.split(',');
                name.forEach((element, index) => {
                  let data = {
                    Username: element,
                    Userid: ids[index]
                  }
                  this.ProjectCs.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.Partner) {
              try {
                let name = res.data.Partner.split(',');
                let ids = res.data.PartnerIds.split(',');
                name.forEach((element, index) => {
                  let data = {
                    Username: element,
                    Userid: ids[index]
                  }
                  this.Partner.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.AttrPerfor) {
              try {
                let name = res.data.AttrPerfor.split(',');
                let ids = res.data.AttrPerforIds.split(',');
                name.forEach((element, index) => {
                  let data = {
                    Username: element,
                    Userid: ids[index]
                  }
                  this.AttrPerfor.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.ProjectOper) {
              try {
                let name = res.data.ProjectOper.split(',');
                let ids = res.data.ProjectOperIds.split(',');
                name.forEach((element, index) => {
                  let data = {
                    Username: element,
                    Userid: ids[index]
                  }
                  this.ProjectOper.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.Project) {
              try {
                let name = res.data.Project.split(',');
                let ids = res.data.ProjectIds.split(',');
                name.forEach((element, index) => {
                  let data = {
                    StrprojectName: element,
                    Projectid: Number(ids[index])
                  }
                  this.Project.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.ServiceType) {
              try {
                this.ServiceType = [];
                let name = res.data.ServiceType.split(',');
                let ids = res.data.ServiceTypeIds.split(',');
                name.forEach((element, index) => {
                  let data = {
                    strParametername: element,
                    strParameterid: ids[index]
                  }
                  this.ServiceType.push(data)
                });
              } catch (e) {
                this.Designated = [];
              }
            }
            if (res.data.ServiceDepId) {
              try {
                this.ServiceDep = [];
                let ids = res.data.ServiceDepId.split(',');
                ids.forEach((element, index) => {
                  this.ServiceDep[index] = [];
                  const reg = /(\d)(?=(?:\d{2})+$)/g;
                  element = element.toString().replace(reg, '$1,');
                  let item = element.split(',')
                  let a = '';
                  item.forEach((e, i) => {
                    if (i == 0) {
                      e = e;
                      a = e;
                    } else {
                      e = a + e;
                      a = e;
                    }
                    this.ServiceDep[index].push(e);
                  });
                });
                this.$nextTick(() => {
                  this.ServiceDep = this.ServiceDep;
                })
              } catch (e) {
                this.Designated = [];
              }
            }
            this.showAddRule = true;
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
      stop(row) {
        if (!this.isloading) {
          this.isloading = true;
          let data = {
            Id: row.Id,
            Enable: row.Enable == '0' ? '1' : '0'
          }
          xz.enableApprovalConfig(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功！');
              this.isloading = false;
              this.getApprovalConfigList();
            } else {
              this.isloading = false;
              this.getApprovalConfigList();
              this.$message.error(res.msg)
            }
          })
        }
      },
      del(row) {
        if (!this.isloading) {
          this.isloading = true;
          let id = row.Id;
          xz.delApprovalConfig(id, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功！');
              this.isloading = false;
              this.getApprovalConfigList();
            } else {
              this.isloading = false;
              this.getApprovalConfigList();
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .stepBox {
    width: 600px;
    margin: 0 auto;
  }

  .stepTitle {
    font-size: 14px;
    height: 57px;
    line-height: 57px;
    margin-right: 20px;
  }

  .formTitle {
    font-weight: 600;
  }

  .formTitle span {
    color: #F59A23;
    font-size: 18px;
  }

  .formTitle2 {
    margin-left: 34px;
    margin-bottom: 15px;
  }

  .symbol {
    margin-right: 10px;
  }

  .unit {
    margin: 0 10px;
  }

  .PriorityTips {
    color: red;
    margin-left: 30px;
  }
</style>
<style>
  .page_salaryProcessSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salaryProcessSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salaryProcessSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salaryProcessSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salaryProcessSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salaryProcessSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salaryProcessSet .el-table__fixed {
    height: 100% !important;
  }

  .el-tooltip__popper {
    max-width: 500px !important;
  }
</style>